import {ChangeEvent, useCallback} from 'react';
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateButton from '../../../../components/Button/CreateButton';
import MsgAddIcon from '../../../../asset/icons/addmsg.svg';
import {IDemoScriptStateProp} from '../../../../dto/demoStingerFulfilment.dto';
import DemoStingerFileUpload from './DemoStingerFileUpload';
type Props = {
  message: IDemoScriptStateProp[];
  setMessage: React.Dispatch<React.SetStateAction<IDemoScriptStateProp[]>>;
};
const DemoStingerStingerSection = ({message, setMessage}: Props) => {
  const handleAddStinger = useCallback(() => {
    setMessage(prevState => [
      ...prevState,
      {
        id: Date.now(),
        name: '',
        file: null,
      },
    ]);
  }, [setMessage]);
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>, id: number) => {
      const {name, value} = e.target;
      setMessage((prevMessages: IDemoScriptStateProp[]) =>
        prevMessages.map(message =>
          message.id === id ? {...message, [name]: value} : message,
        ),
      );
    },
    [setMessage],
  );
  const handleDelete = useCallback(
    (id: number) => {
      setMessage(prevMessages =>
        prevMessages.filter(message => message.id !== id),
      );
    },
    [setMessage],
  );
  return (
    <Box>
      <Stack direction='row' alignItems='center' spacing={2}>
        <Typography variant='h3'>Attach Partner Stinger</Typography>
        <CreateButton
          className='float-right mr-10'
          title='Add Stinger'
          onClick={handleAddStinger}
          icon={MsgAddIcon}
        />
      </Stack>
      <TableContainer className='max-h-500 overflow-auto scrollbar'>
        <Table
          sx={{
            '.MuiTableCell-root, .MuiTableRow-root': {
              border: 'none !important',
              padding: '6px',
            },
          }}>
          <TableBody>
            {message.map((val, index) => (
              <TableRow key={val.id}>
                <TableCell className='text-white-30'>
                  <Typography variant='subtitle1'>
                    Stinger {index + 1}
                  </Typography>
                </TableCell>
                <TableCell className='text-white-30'>
                  <TextField
                    name='name'
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      handleChange(e, val.id);
                    }}
                    label='stinger name'></TextField>
                </TableCell>
                <TableCell className='text-white-30'>
                  <DemoStingerFileUpload
                    id={val.id}
                    setMessage={setMessage}
                    message={val}></DemoStingerFileUpload>
                </TableCell>
                <TableCell>
                  {message.length > 2 && (
                    <DeleteIcon
                      className='pointer-cursor'
                      onClick={() => {
                        handleDelete(val.id);
                      }}
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default DemoStingerStingerSection;
